<template>
  <div>
    <div id="overlay"  v-if="loading">
      <div class="spinner"></div>
      <br/>
        <h4>Loading...</h4>
    </div>
    <form>
      <div class="p-grid">
        <div class="p-col">
          <!-- <Button class="p-button-raised p-button-rounded"  @click.prevent="openBasic" icon="pi pi-plus" label="NEW" /> -->
          <Button class="p-button p-component addNewBtn btn-btm-0"  @click.prevent="openBasic" label="NEW"/>
        </div>
      </div>
      <Dialog header="Account Child SubHead" :visible.sync="displayBasic"
       :style="{width: '50vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}" >
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-6">
            <label for="name">Name<span style="color:red">*</span></label>
            <InputText v-if="!systemOnly" ref="name" v-model.trim="name"  id="name" />
            <InputText v-else ref="name" v-model.trim="name"  id="name" disabled/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="shortName">Short Name</label>
            <InputText v-model.trim="shortName" id="shortName" />
          </div>
          <div class="p-field p-col-12 p-md-6">
           <label for="head">Account Sub Child Group<span style="color:red">*</span></label>
           <!-- <Dropdown v-if="!systemOnly" v-model="accountHeadId" :options="accountHeadLists" optionLabel="name" placeholder="Select Account Group" :filter="true" :showClear="true"/> -->
           <Dropdown  v-model="accountHeadId" :options="accountHeadLists" optionLabel="name" placeholder="Select Parent Group" :filter="true" :showClear="true" />
          </div>
          <accountgroupdialog style="margin-top:1.3em"  @set_data="set_data"/>
        </div>
     <template #footer>
      <Button class="p-button-raised p-button-rounded" @click.prevent="addAccountSubHead" :label="!editing?'Add':'Update'"/>
      <Button class="p-button-raised p-button-info" @click.prevent="saveAndNewAccountSubGroup" v-if="!editing" label="Add & New"/>
      <Button class="p-button-raised p-button-danger" @click.prevent="cancel" label="Cancel"/>
      </template>
    </Dialog>
   </form>
  </div>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import Dialog from 'primevue/dialog'
import InputText from 'primevue/inputtext'
import accountgroupdialog from './AccountGroupDialog.vue'
import Button from 'primevue/button'
export default {
  name: 'accountSubgroup',
  data() {
    return {
      name: '',
      accountHeadId: '',
      shortName: '',
      editing: false,
      displayBasic: false,
      id: '',
      loading: false,
      systemOnly: false
    }
  },
  computed: {
    accountHeadLists() {
      return this.$store.state.accountHead.accountSubHeadDropList
    }
  },
  mounted() {
    this.accountHeadList()
  },
  methods: {
    async addAccountSubHead() {
      if (this.name.trim() === '' || this.accountHeadId === '' || this.accountHeadId === null) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Data must not be empty!', life: 10000})
        return
      }
      let response = ''
      let accountSubhead = {
        name: this.name,
        parentId: this.accountHeadId.id,
        shortName: this.shortName,
        id: this.id
      }
      try {
        if (!this.editing) {
          this.loading = !this.loading
          response = await this.$store.dispatch('createAccountSubHead', accountSubhead)
          this.$emit('set_data_subhead', response.data.data)
          this.loading = false
        } else {
          this.loading = !this.loading
          response = await this.$store.dispatch('updateAccountSubHead', accountSubhead)
          this.loading = false
        }
      } catch (e) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Something went wrong!!', life: 3000})
        this.loading = false
        return
      }

      this.responseCheck(response)
      this.closeBasic()
    },
    async saveAndNewAccountSubGroup() {
      if (this.name.trim() === '' || this.accountHeadId === '' || this.accountHeadId === null) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Data must not be empty!', life: 3000})
        return
      }
      let response = ''
      let accountSubhead = {
        name: this.name,
        parentId: this.accountHeadId.id,
        shortName: this.shortName,
        id: this.id
      }
      try {
        this.loading = !this.loading
        response = await this.$store.dispatch('createAccountSubHead', accountSubhead)
        this.loading = false
      } catch (e) {
        this.$toast.add({severity: 'success', summary: '', detail: 'Something went wrong!!', life: 10000})
        this.loading = false
        return
      }
      this.responseCheck(response)
      this.focusAfterSave()
    },
    async accountHeadList() {
      try {
        await this.$store.dispatch('accountSubHeadChildDropDown')
      } catch (e) {
        this.$toast.add({severity: 'success', summary: '', detail: 'Something went wrong!!', life: 10000})
      }
    },
    set_data(data) {
      this.accountHeadId = data
    },
    responseCheck(response) {
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
        this.reset()
        return
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
        this.reset()
        return
      }
    },
    cancel() {
      this.name = ''
      this.accountHeadId = ''
      this.shortName = ''
      this.editing = false
      this.displayBasic = false
    },
    editAccount(data) {
      this.editing = true
      this.name = data.name
      this.shortName = data.shortName
      this.accountHeadId = data.accountParentId
      this.id = data.id
      this.systemOnly = data.isSystemOnly
      this.openBasic()
      // // debugger
    },
    reset() {
      this.name = ''
      this.accountHeadId = ''
      this.shortName = ''
      this.editing = false
    },
    openBasic() {
      this.displayBasic = true
    },
    closeBasic() {
      this.displayBasic = false
    },
    focusAfterSave() {
      this.$nextTick(function() {
        this.$refs.name.$el.focus()
      })
    }
  },
  components: {
    Dropdown,
    Dialog,
    InputText,
    accountgroupdialog,
    Button
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// AccountChildSubGroupDialog.vue?2d455632